module.exports = __webpack_public_path__ + "static/media/Rectangle1.b6247ad0.png";